import { Button, ButtonProps } from '@mui/material';
import { useEffect } from 'react';
import { Contract_Status_Enum } from '@kheops/graphql';
import useOpenable from '../hooks/useOpenable';
import { useCompanyByIdLazyQuery } from '../queries/__generated__/companyById.generated';
import ContractRequestDialog from './contractRequest/ContractRequestDialog';

export interface ContractRequestButtonProps {
  companyId: string;
  buttonProps?: ButtonProps;
  contractStatus?: Contract_Status_Enum;
  buttonContent?: string | React.JSX.Element;
}

export default function ContractRequestButton({ contractStatus, companyId, buttonProps, buttonContent }: ContractRequestButtonProps): React.JSX.Element {
  const [companyByIdQuery, { data: companyData, loading }] = useCompanyByIdLazyQuery({
    variables: {
      companyId: companyId!,
    },
  });
  const isContractUnsigned = contractStatus === Contract_Status_Enum.Unsigned;
  const { isOpen: isContactRequestDialogOpen, open: openContactRequest, close: closeContractRequest } = useOpenable();

  const handleClick = (): void => {
    if (companyData?.company_by_pk?.id) {
      openContactRequest();
    } else {
      companyByIdQuery();
    }
  };

  useEffect((): void => {
    if (companyData?.company_by_pk?.id) {
      openContactRequest();
    }
  }, [companyData]);

  return (
    <>
      <Button
        loading={loading}
        disabled={isContractUnsigned}
        onClick={() => handleClick()}
        variant="contained"
        {...buttonProps}
      >
        {buttonContent}
      </Button>
      {companyData && (
        <ContractRequestDialog
          onCancel={closeContractRequest}
          isOpen={isContactRequestDialogOpen}
          onClose={closeContractRequest}
          companyInfo={companyData!.company_by_pk!}
        />
      )}
    </>
  );
}
